import { summariseRecordsUpdated } from "features/patients/utils/patientMerge";

import styles from "../MergePatientsPage.module.css";

// What actually moved, as the merge reported it. This is only ever shown afterwards:
// the backend returns `recordsUpdated` with the merge result and there is no endpoint
// that will say in advance what a merge would move.
export const MergeResultSummary = ({ recordsUpdated }) => {
  const { rows, total } = summariseRecordsUpdated(recordsUpdated);

  return (
    <div className={styles.resultPanel}>
      <p className={styles.resultLead}>
        {total === 0
          ? "No linked records were found to move."
          : `${total} record${total === 1 ? "" : "s"} moved onto the record you kept:`}
      </p>
      {rows.length > 0 && (
        <ul className={styles.resultList}>
          {rows.map((row) => (
            <li key={row.label} className={styles.resultRow}>
              <span>{row.label}</span>
              <span className={styles.resultCount}>{row.count}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
